module.exports = __webpack_public_path__ + "img/logo_small@2x.44a28bf9.png";